import * as React from 'react';
import { GeneralPromoLink } from './general_promo_link';
import { IPromoLink } from '../../../types/promo';

interface IProps {
  id: string;
  title: string;
  titleLink?: IPromoLink;
  links: IPromoLink[];
  type?: string;
  backgroundClassName: string;
  blockClassName: string;
}

const s = require('../vertical_promo_blocks.css');

export class GeneralPromoBlock extends React.Component<IProps> {
  public render() {
    return (
      <div
        className={`${s['c-new-promo-block']}
                        ${s[this.props.backgroundClassName]}
                        ${this.props.blockClassName}`}
      >
        <div
          className={`${s['c-new-promo-block-content']}
                      ${s['c-new-promo-block-content-link']}`}
        >
          {this.props.links.map((link: IPromoLink, i: number) => (
            <GeneralPromoLink rootTitle={this.props.title} key={`promo-link-${i}`} {...link} />
          ))}
        </div>
      </div>
    );
  }
}
